import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, CardActions, Modal, Box, Select, InputLabel, Divider, Backdrop, CircularProgress } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers';
// import AcceptanaceStatHeader from '../acceptance-stat/AcceptanaceStatHeader';
import SettingsHeader from './SettingsHeader';
import debounce from 'lodash.debounce';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    pageSize: number;
    anchorEl: any;
    acceptanceData: any[];
    filter: any;
    status: any;
    community: any;
    survey: any;
    page: any;
    limit: any;
    type: any;
    community_id: any;
    showLoader: boolean;
    routes: any;
    rowCount: any;
}

class AcceptanceStat extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            pageSize: 20,
            anchorEl: null,
            acceptanceData: [],
            filter: '',
            status: '',
            community: '',
            survey: '',
            page: 0,
            limit: 20,
            type: 'tc_accepted',
            community_id: '',
            showLoader: false,
            routes: [],
            rowCount: 0,
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });

        // this.setState({
        //     acceptanceData:[
        //         {
        //           "id": 6,
        //           "community_name": "Hill county",
        //           "user_id": 633,
        //           "users_name": "Roshan",
        //           "start_date": "2023-09-19",
        //           "end_date": "2023-09-20",
        //           "is_active": 1,
        //           "status": "Pickup will be pause between selected dates"
        //         },
        //         {
        //           "id": 366,
        //           "community_name": "Eldeco Utopia",
        //           "user_id": 21919,
        //           "users_name": "Anupama das",
        //           "start_date": "2023-09-15",
        //           "end_date": "2024-03-16",
        //           "is_active": 1,
        //           "status": "Pickup will be pause between selected dates"
        //         },
        //         {
        //           "id": 6,
        //           "community_name": "Hill county",
        //           "user_id": 633,
        //           "users_name": "Roshan",
        //           "start_date": "2023-09-15",
        //           "end_date": "2023-09-04",
        //           "is_active": 1,
        //           "status": "Pickup will be pause between selected dates"
        //         },
        //         {
        //           "id": 19,
        //           "community_name": "Zone Kukatpally",
        //           "user_id": 14258,
        //           "users_name": "Vijay",
        //           "start_date": "2023-09-14",
        //           "end_date": "2023-12-14",
        //           "is_active": 1,
        //           "status": "Pickup will be pause between selected dates"
        //         },
        //         {
        //           "id": 6,
        //           "community_name": "Hill county",
        //           "user_id": 633,
        //           "users_name": "Roshan",
        //           "start_date": "2023-09-04",
        //           "end_date": "2023-09-07",
        //           "is_active": 1,
        //           "status": "Pickup will be pause between selected dates"
        //         },
        //         {
        //           "id": 6,
        //           "community_name": "Hill county",
        //           "user_id": 633,
        //           "users_name": "Roshan",
        //           "start_date": "2023-08-30",
        //           "end_date": "2023-08-31",
        //           "is_active": 1,
        //           "status": "Pickup will be pause between selected dates"
        //         },
        //         {
        //           "id": 6,
        //           "community_name": "Hill county",
        //           "user_id": 633,
        //           "users_name": "Roshan",
        //           "start_date": "2023-08-29",
        //           "end_date": "2023-09-28",
        //           "is_active": 1,
        //           "status": "Pickup will be pause between selected dates"
        //         },
        //         {
        //           "id": 112,
        //           "community_name": "HSR Layout Zone",
        //           "user_id": 25192,
        //           "users_name": "Govindan K",
        //           "start_date": "2023-08-24",
        //           "end_date": "2023-08-29",
        //           "is_active": 0,
        //           "status": "Pickup will be pause between selected dates"
        //         },
        //         {
        //           "id": 19,
        //           "community_name": "Zone Kukatpally",
        //           "user_id": 14258,
        //           "users_name": "Vijay",
        //           "start_date": "2023-08-23",
        //           "end_date": "2023-08-30",
        //           "is_active": 0,
        //           "status": "Pickup will be pause between selected dates"
        //         },
        //         {
        //           "id": 19,
        //           "community_name": "Zone Kukatpally",
        //           "user_id": 14258,
        //           "users_name": "Vijay",
        //           "start_date": "2023-08-23",
        //           "end_date": "2023-08-30",
        //           "is_active": 0,
        //           "status": "Pickup will be pause between selected dates"
        //         }
        //       ]
              
              
        // })
        this.fetchRoutes()
        this.fetchAcceptanceData();
    }

    public fetchRoutes() {
        axios.get(`allCommunitiesLite`, {
            params: { hierarchies: this.props.user.selectedHierarchyIds },
        }).then((response) => {
            let data: any = response.data.data;
            // let routes: any = [];
            // data.map((route: any) => {
            //     routes[route.id] = {
            //         id: route.id,
            //         route: route.name,
            //         hierarchy_id: route.hierarchy_id,
            //         hierarchy_name: route.hierarchy_name,
            //     };
            // });
            this.setState({ routes: data });
            // console.log("routes",this.state.routes);
        });
    }

    handleSearch = debounce((page: number = 0, limit: number = this.state.pageSize) => {
        this.fetchAcceptanceData(page,limit);
      }, 800);

    public fetchAcceptanceData (page: number = this.state.page, limit: number = this.state.pageSize) {
        this.setState({showLoader: true})
        let body = {
            "hierarchies": this.props.user.selectedHierarchyIds,
            "filter": this.state.filter,
            "type": this.state.type,
            "community_id": this.state.community_id,
            "page": page+1,
            "limit": limit,
        }
        axios.post('getCustomerAcceptanceStats', body, {headers: {"Content-Type": "application/json"}}).then((response: any) => {
            if(response.data.success){
                // console.log("data", response.data.data);
                let tempdata = response.data.data.data;

                let details: any[] = [];
                details = tempdata?.map((el: any) => {
                    // let temp = this.state.routes.filter((element: any) => element.id == el.user.community?.community_id)
                    // console.log("temp",temp);
                    return{
                        "id": el.user_id,
                        "users_name": el.user.name,
                        "mobile": el.user.phone,
                        "email": el.user.email,
                        "hno": el.location,
                        "community": this.state.routes?.filter((ele: any) => ele.id == el.user.community?.community_id)[0]?.name,
                        "status": el.user.is_active,
                    }
                }) 
                this.setState({acceptanceData: details, showLoader: false, rowCount: response.data.data.total});
                console.log("data", this.state.acceptanceData);
            } else {
                // console.log("err");
                this.setState({showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);

        const columns = [
            {
                headerName: "ID",
                field: "id",
                width: 100,
            },
            {
                headerName: "Customer Name",
                field: "users_name",
                width: 200,
            },
            {
                headerName: "Mobile",
                field: "mobile",
                width: 200,
            },
            {
                headerName: "Email",
                field: "email",
                width: 200,
            },
            {
                headerName: "House No.",
                field: "hno",
                width: 200,
            },
            {
                headerName: "Community",
                field: "community",
                width: 200,
            },
            {
                headerName: "Status",
                field: "status",
                width: 400,
                renderCell: (params: GridCellParams) => (
                    <Typography className={(params.row.status == 1) ? 'statusTextSuccess' : 'statusTextError'}>{params.row.status == 1 ? "Active" : "Inactive"}</Typography>
                )
            },
          ];
          

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>

                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <SettingsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card style={{height: 600}}>
                            <CardHeader
                                title={<>
                                    <Grid container spacing={2}>
                                        <Grid item md={2} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("List of Customers")}</Typography>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <TextField
                                                    id="filter-input"
                                                    label={t("Search")}
                                                    name="filter"
                                                    value={this.state.filter}
                                                    onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.handleSearch())}
                                                    fullWidth={true}
                                                    size="small"
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <InputLabel id="route-type-label">{t("Community")}</InputLabel>
                                                <Select
                                                    labelId="route-type-label"
                                                    value={this.state.community_id}
                                                    onChange={(e: any) => this.setState({ "community_id": e.target.value }, () => this.fetchAcceptanceData())}
                                                    displayEmpty
                                                    label={t("Community")}
                                                >
                                                    {/* <MenuItem key={'all'} value={'all'}>{t("All")}</MenuItem>
                                                    <MenuItem key={'Shobha International city'} value={'Shobha International city'}>{t("Shobha International city")}</MenuItem>
                                                    <MenuItem key={'Kattedan'} value={'Kattedan'}>{t("Kattedan")}</MenuItem> */}
                                                    {
                                                        this.state.routes.map((el: any) => {
                                                            return(
                                                                <MenuItem key={el.name} value={el.id}>{el.name}</MenuItem>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <InputLabel id="route-type-label">{t("Survey")}</InputLabel>
                                                <Select
                                                    labelId="route-type-label"
                                                    value={this.state.survey}
                                                    onChange={(e: any) => this.setState({ "survey": e.target.value }, () => this.fetchAcceptanceData())}
                                                    displayEmpty
                                                    label={t("Status")}
                                                >
                                                    <MenuItem key={'Terms Accepted Status'} value={'tc_accepted'}>{t("Terms Accepted Status")}</MenuItem>
                                                    <MenuItem key={'Survey Status'} value={'is_survey_completed'}>{t("Survey Status")}</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <InputLabel id="route-type-label">{t("Status")}</InputLabel>
                                                <Select
                                                    labelId="route-type-label"
                                                    value={this.state.status}
                                                    onChange={(e: any) => this.setState({ "status": e.target.value })}
                                                    displayEmpty
                                                    label={t("Status")}
                                                >
                                                    <MenuItem key={'Accepted'} value={'Accepted'}>{t("Accepted")}</MenuItem>
                                                    <MenuItem key={'Rejected'} value={'Rejected'}>{t("Rejected")}</MenuItem>
                                                    <MenuItem key={'Pending'} value={'Pending'}>{t("Pending")}</MenuItem>

                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <Button variant='contained'>Download</Button>
                                        </Grid>
                                        
                                    </Grid>
                                </>
                                }
                                className="text-left"
                            />

                            <CardContent>
                                <DataGrid
                                    aria-label="List of Barcoded Bags"
                                    columns={columns}
                                    rows={this.state.acceptanceData}
                                    rowCount={this.state.rowCount}
                                    pageSize={this.state.pageSize}
                                    onPageChange={(page) => this.fetchAcceptanceData(page)}
                                    onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize }, () => this.fetchAcceptanceData(0, newPageSize))}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    // autoHeight={true}
                                    style={{height: 500}}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                    onRowClick={(params: GridRowParams) => {
                                        this.props.history.push('/customers/' + params.id)
                                    }}
                                    paginationMode="server"
                                    className="clickableList"
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                
            </div>
        )
    }
}

export default withRouter(withTranslation()(AcceptanceStat))